import React, { useCallback, useEffect, useRef, useState } from 'react';
type Slide = {
  src: string;
  alt: string;
  caption: string;
};
const SLIDES: Slide[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/8NCwfM8x7sUPSS9YrTTpFL/1-removebg-preview_(1).webp',
  alt: 'Protocolo Energía Real en tablet y celular junto a los planificadores imprimibles de los 3 bonos',
  caption: '4 tomos + 3 bonos imprimibles'
}];
export function HeroCarousel() {
  const trackRef = useRef<HTMLDivElement | null>(null);
  const dragState = useRef({
    active: false,
    startX: 0,
    startScroll: 0,
    moved: false
  });
  const [index, setIndex] = useState(0);
  const handleScroll = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;
    const next = Math.round(track.scrollLeft / track.clientWidth);
    setIndex(current => current === next ? current : next);
  }, []);
  const goTo = useCallback((target: number) => {
    const track = trackRef.current;
    if (!track) return;
    track.scrollTo({
      left: target * track.clientWidth,
      behavior: 'smooth'
    });
  }, []);

  // Click & drag en desktop (en mobile el swipe nativo ya funciona).
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onPointerDown = (event: PointerEvent) => {
      if (event.pointerType === 'touch') return;
      dragState.current = {
        active: true,
        startX: event.clientX,
        startScroll: track.scrollLeft,
        moved: false
      };
      track.style.scrollSnapType = 'none';
      track.setPointerCapture(event.pointerId);
    };
    const onPointerMove = (event: PointerEvent) => {
      if (!dragState.current.active) return;
      const delta = event.clientX - dragState.current.startX;
      if (Math.abs(delta) > 4) dragState.current.moved = true;
      track.scrollLeft = dragState.current.startScroll - delta;
    };
    const endDrag = (event: PointerEvent) => {
      if (!dragState.current.active) return;
      dragState.current.active = false;
      track.style.scrollSnapType = '';
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      const nearest = Math.round(track.scrollLeft / track.clientWidth);
      track.scrollTo({
        left: nearest * track.clientWidth,
        behavior: 'smooth'
      });
    };
    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    return () => {
      track.removeEventListener('pointerdown', onPointerDown);
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', endDrag);
      track.removeEventListener('pointercancel', endDrag);
    };
  }, []);
  return <div className="mt-7" data-id="element-114" data-mp="mmyw735o67k9">
      <div ref={trackRef} onScroll={handleScroll} className="no-scrollbar flex w-full snap-x snap-mandatory overflow-x-auto overscroll-x-contain scroll-smooth cursor-grab active:cursor-grabbing" role="group" aria-roledescription="carrusel" aria-label="Imágenes del Protocolo Energía Real" tabIndex={0} data-id="element-115" data-mp="mqmnrwrk0jwc">
        {SLIDES.map((slide, slideIndex) => <figure key={slide.src} className="w-full shrink-0 snap-center px-0.5" aria-roledescription="diapositiva" aria-label={`${slideIndex + 1} de ${SLIDES.length}`} data-id="element-116" data-mp="g8tfrqk0fwgt" data-mpi={slideIndex}>
            <div className="overflow-hidden rounded-xl border border-line bg-paper shadow-card" data-id="element-117" data-mp="18wyy66nld9dh">
              <img src={slide.src} alt={slide.alt} className="aspect-square w-full select-none bg-paper object-contain p-2" draggable={false} loading={slideIndex === 0 ? 'eager' : 'lazy'} data-id="element-118" data-mp="1dw24dufb5ln1" />
            </div>
            <figcaption className="mt-2.5 text-center text-[12px] font-semibold uppercase tracking-[0.1em] text-teal-600" data-id="element-119" data-mp="1468q2lns6sf3">
              {slide.caption}
            </figcaption>
          </figure>)}
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-120" data-mp="1wm9t37i9g9jp">
        {SLIDES.map((slide, dotIndex) => <button key={slide.src} type="button" onClick={() => goTo(dotIndex)} aria-label={`Ver imagen ${dotIndex + 1}`} aria-current={dotIndex === index} className={`h-2 rounded-full transition-all duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-night ${dotIndex === index ? 'w-6 bg-flame' : 'w-2 bg-line hover:bg-muted/50'}`} data-id="element-121" data-mp="818dxvgs5gmr" data-mpi={dotIndex} />)}
      </div>
    </div>;
}